import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  SustainableFitchSiteFooter,
  SustainableFitchSiteFooterProps
} from 'suf_storybook'

import { Query } from '../generated/gatsby.types'

export type Props = {
  handleCookiesClick: () => void
  handlePreferencesClick?: () => void
  versoin?: string
}

const query = graphql`
  query SiteFooterQuery {
    contentfulTopNavigation(label: { eq: "SF Footer Menu" }) {
      label
      navigation {
        label
        title
        text {
          text
        }
        menus {
          title
          label
          target
          relatedLinkHref: href
          links {
            __typename
            ... on ContentfulLink {
              label
              target
              linkHref: href {
                href
              }
            }
            ... on ContentfulRelatedLinks {
              title
              label
              target
              relatedLinkHref: href
              links {
                ... on ContentfulLink {
                  label
                  target
                  linkHref: href {
                    href
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

const parseSiteHeaderProps = ({
  handlePreferencesClick = () => {},
  handleCookiesClick = () => {},
  contentfulTopNavigation,
  version
}: Query & Props): SustainableFitchSiteFooterProps => {
  return {
    navigation: contentfulTopNavigation!.navigation,
    handlePreferencesClick,
    handleCookiesClick,
    version
  }
}

export default (props: Props) => {
  const data: Query = useStaticQuery(query)
  return (
    <SustainableFitchSiteFooter
      {...parseSiteHeaderProps({ ...data, ...props })}
    />
  )
}
